/* Etiquetas multiidoma en inglés. */
export default {
  "contactView.name": "Name",
  "contactView.phone": "Mobile phone",
};
